var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.773842,
    y: 0.773842,
    width: 37.1444,
    height: 37.1444,
    rx: 18.5722,
    stroke: "#FCC436",
    strokeWidth: 1.54768
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1856 14.3162L23.6642 15.8376L26.4481 18.6323H15.4742V20.7904H26.4481L23.6642 23.5743L25.1856 25.1066L30.5808 19.7114L25.1856 14.3162ZM11.1581 12.1581H19.7904V10H11.1581C9.97114 10 9 10.9711 9 12.1581V27.2647C9 28.4516 9.97114 29.4227 11.1581 29.4227H19.7904V27.2647H11.1581V12.1581Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 1.20144,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.d60dd1a3860f60736646f09df4cff086.svg";
export { ForwardRef as ReactComponent };